// extracted by mini-css-extract-plugin
export default {"title_box":"datasComponent_title_box__edhJJ","img_box":"datasComponent_img_box__UedF6","single_img":"datasComponent_single_img__dQj6w","btn":"datasComponent_btn__VCg0c"};